import { createFileRoute, Outlet } from '@tanstack/react-router'
import { PetRepositoriesProvider } from '_/features/pets/ui/contexts/pet-repositories-provider'

const PetsLayout = () => {
	return (
		<PetRepositoriesProvider>
			<Outlet />
		</PetRepositoriesProvider>
	)
}

export const Route = createFileRoute('/_authenticated/pets')({
	component: PetsLayout,
})
